
(function(){
  /* ===== NICHE AVENUE — LGPD COOKIE BANNER + NEWSLETTER POPUP ===== */
  
  /* ===== 1. LGPD COOKIE CONSENT ===== */
  if(!localStorage.getItem('niche_lgpd_consent')){
    var cb = document.createElement('div');
    cb.id = 'niche-lgpd-banner';
    cb.innerHTML = '<div style="max-width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap"><p style="margin:0;font-size:13px;color:#e8e0d0;line-height:1.5;flex:1;min-width:280px">Utilizamos cookies para melhorar sua experi\u00eancia. Ao continuar navegando, voc\u00ea concorda com nossa <a href="/policies/privacy-policy" style="color:#c4a265;text-decoration:underline">Pol\u00edtica de Privacidade</a>.</p><div style="display:flex;gap:10px;flex-shrink:0"><button id="niche-lgpd-accept" style="background:#c4a265;color:#0a0a0a;border:none;padding:10px 24px;font-size:12px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;font-family:inherit">Aceitar</button><button id="niche-lgpd-reject" style="background:transparent;color:#c4a265;border:1px solid #c4a265;padding:10px 24px;font-size:12px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;font-family:inherit">Rejeitar</button></div></div>';
    cb.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#0a0a0a;padding:16px 24px;z-index:99999;border-top:1px solid #c4a265;box-shadow:0 -4px 20px rgba(0,0,0,0.4);animation:nicheSlideUp 0.4s ease';
    document.body.appendChild(cb);
    
    var style = document.createElement('style');
    style.textContent = '@keyframes nicheSlideUp{from{transform:translateY(100%);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes nicheFadeIn{from{opacity:0}to{opacity:1}}@keyframes nicheScaleIn{from{transform:scale(0.9);opacity:0}to{transform:scale(1);opacity:1}}';
    document.head.appendChild(style);
    
    document.getElementById('niche-lgpd-accept').onclick = function(){
      localStorage.setItem('niche_lgpd_consent','accepted');
      cb.style.transition='transform 0.3s ease,opacity 0.3s ease';
      cb.style.transform='translateY(100%)';cb.style.opacity='0';
      setTimeout(function(){cb.remove()},300);
    };
    document.getElementById('niche-lgpd-reject').onclick = function(){
      localStorage.setItem('niche_lgpd_consent','rejected');
      cb.style.transition='transform 0.3s ease,opacity 0.3s ease';
      cb.style.transform='translateY(100%)';cb.style.opacity='0';
      setTimeout(function(){cb.remove()},300);
    };
  }
  
  /* ===== 2. NEWSLETTER POPUP ===== */
  if(!localStorage.getItem('niche_newsletter_shown') && !sessionStorage.getItem('niche_newsletter_session')){
    setTimeout(function(){
      sessionStorage.setItem('niche_newsletter_session','1');
      var overlay = document.createElement('div');
      overlay.id = 'niche-nl-overlay';
      overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.7);z-index:100000;display:flex;align-items:center;justify-content:center;animation:nicheFadeIn 0.3s ease;backdrop-filter:blur(4px)';
      
      overlay.innerHTML = '<div id="niche-nl-popup" style="background:#0a0a0a;border:1px solid #c4a265;max-width:440px;width:90%;padding:40px 32px;text-align:center;position:relative;animation:nicheScaleIn 0.4s ease"><button id="niche-nl-close" style="position:absolute;top:12px;right:16px;background:none;border:none;color:#888;font-size:24px;cursor:pointer;line-height:1">&times;</button><div style="color:#c4a265;font-size:28px;margin-bottom:8px">\u2726</div><h3 style="font-family:Cormorant Garamond,Georgia,serif;font-size:26px;color:#faf8f5;margin:0 0 8px;font-weight:600;letter-spacing:0.02em">Ganhe 10% OFF</h3><p style="color:#a09880;font-size:14px;margin:0 0 24px;line-height:1.5">Na sua primeira compra. Receba ofertas exclusivas e novidades da perfumaria \u00e1rabe.</p><div id="niche-nl-form" style="display:flex;gap:8px"><input id="niche-nl-email" type="email" placeholder="Seu melhor email" style="flex:1;padding:12px 16px;background:#1a1a1a;border:1px solid #333;color:#faf8f5;font-size:14px;font-family:inherit;outline:none"><button id="niche-nl-submit" style="background:#c4a265;color:#0a0a0a;border:none;padding:12px 20px;font-size:12px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;cursor:pointer;font-family:inherit;white-space:nowrap">Quero!</button></div><p id="niche-nl-msg" style="color:#c4a265;font-size:13px;margin:12px 0 0;display:none"></p></div>';
      
      document.body.appendChild(overlay);
      
      function closePopup(){
        overlay.style.transition='opacity 0.3s ease';
        overlay.style.opacity='0';
        setTimeout(function(){overlay.remove()},300);
        localStorage.setItem('niche_newsletter_shown', Date.now());
      }
      
      document.getElementById('niche-nl-close').onclick = closePopup;
      overlay.onclick = function(e){if(e.target===overlay)closePopup()};
      
      document.getElementById('niche-nl-submit').onclick = function(){
        var email = document.getElementById('niche-nl-email').value.trim();
        if(!email || !email.includes('@')){
          var msg = document.getElementById('niche-nl-msg');
          msg.textContent='Por favor, insira um email v\u00e1lido.';
          msg.style.display='block';msg.style.color='#ff6b6b';
          return;
        }
        var btn = this;
        btn.textContent='Enviando...';btn.disabled=true;
        
        var formData = new FormData();
        formData.append('form_type','customer');
        formData.append('utf8','\u2713');
        formData.append('customer[email]',email);
        formData.append('customer[tags]','newsletter,popup,bemvindo10');
        
        fetch('/contact',{method:'POST',body:formData})
        .then(function(){
          document.getElementById('niche-nl-form').style.display='none';
          var msg = document.getElementById('niche-nl-msg');
          msg.innerHTML='\u2728 Use o c\u00f3digo <strong style="color:#faf8f5;font-size:16px">BEMVINDO10</strong> no checkout!';
          msg.style.display='block';msg.style.color='#c4a265';msg.style.fontSize='15px';
          setTimeout(closePopup, 5000);
        })
        .catch(function(){
          btn.textContent='Quero!';btn.disabled=false;
          var msg = document.getElementById('niche-nl-msg');
          msg.textContent='Erro ao cadastrar. Tente novamente.';
          msg.style.display='block';msg.style.color='#ff6b6b';
        });
      };
      
      document.getElementById('niche-nl-email').addEventListener('keypress',function(e){
        if(e.key==='Enter')document.getElementById('niche-nl-submit').click();
      });
      
    }, 8000);
  }
})();
